module.exports = __webpack_public_path__ + "static/media/SplashScreen.8764b995.png";